import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';

import { AuthService } from "../services/auth.service";
import { sha256 } from "js-sha256";
import { User } from "../models/user";
import { EncryptDecryptService } from "../services/encrypt-decrypt.service";
import { HttpClient } from "@angular/common/http";
import { VariablesGlobales } from '../services/globals';
import { ConfigItem, ConfigService } from '../services/config.service';
@Component({ templateUrl: 'auth.component.html' })
export class AuthComponent implements OnInit {

  @Input() identifiant: string;
  @Input() pass: string;
  loading = false;
  errorLogin = false;
  returnUrl: string;
  apikey: string;
  userKey: string;
  config = ConfigService.GetItem;
  tooltip = "Après votre connexion, veuillez cliquer sur l'icône en haut à droite.\n Vous pourrez alors accéder à la gestion de votre profil."
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private encdec: EncryptDecryptService,
    private http: HttpClient,
    public param: VariablesGlobales,

  ) {
    // redirect to home if already logged in
    if (this.authService.currentUserValue) {
      this.router.navigate(['/']);
    }
    this.route.queryParams.subscribe(params => {
      this.userKey = params['cc']; // --> Name must match wanted parameter
      if (!this.userKey)
        this.userKey = params['cle'];
    });
  }

  ngOnInit() {
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.apikey = localStorage.getItem('apikey');
    if (this.userKey)
      this.submitCC();
  }


  submitCC() {
    this.loading = true;
    this.http.get('https://api2.sitederecrutement.com/Home/getcandidate?apikey=' + this.apikey + '&login=' + this.userKey, { responseType: "text" })
      .subscribe(
        (result) => {
          if (result.includes('Error')) {
            this.loading = false;
            this.errorLogin = true;
          } else {
            if (this.encdec.getDecrypt(result) !== 'null') {
              let data = this.encdec.getDecrypt(result);
              //console.log(data);
              let obj = JSON.parse(data);
              const user: User = {
                idcandidat: obj.idcandidat,
                can_echec_connexion: obj.can_echec_connexion,
                can_echec_connexion_date: obj.can_echec_connexion_date,
                can_echec_connexion_heure: obj.can_echec_connexion_heure,
                can_passe_date: obj.can_passe_date,
                candidat_api: obj.can_session_api,
                can_passe_modif: obj.can_passe_modif,
                photo: obj.photo,
                consentement: obj.consentement,
                nom: obj.can_nom,
                prenom: obj.can_prenom,
                mail: obj.can_mail,
                portable: obj.can_tel_mob
              }
              // console.log(user.candidat_api);
              localStorage.setItem('currentUser', JSON.stringify(user));
              this.loading = false;
              this.router.navigate(['profil']);
            }
            else {
              this.loading = false;
              this.errorLogin = true;
            }
          }
        },
        error => {
          console.error(error);
          this.loading = false;
          this.errorLogin = true;
        });
  }

  onSubmit() {
    this.loading = true;
    this.http.get('https://api2.sitederecrutement.com/Home/getcandidate?apikey=' + this.apikey + '&login=' + this.identifiant + '&pass=' + sha256(this.pass), { responseType: "text" })
      .subscribe(
        (result) => {
          if (result.includes('Error')) {
            this.loading = false;
            this.errorLogin = true;
          } else {
            if (this.encdec.getDecrypt(result) !== 'null') {
              let data = this.encdec.getDecrypt(result);
              let obj = JSON.parse(data);
              const user: User = {
                idcandidat: obj.idcandidat,
                can_echec_connexion: obj.can_echec_connexion,
                can_echec_connexion_date: obj.can_echec_connexion_date,
                can_echec_connexion_heure: obj.can_echec_connexion_heure,
                can_passe_date: obj.can_passe_date,
                candidat_api: obj.can_session_api,
                can_passe_modif: obj.can_passe_modif,
                photo: obj.photo,
                consentement: obj.consentement,
                nom: obj.can_nom,
                prenom: obj.can_prenom,
                mail: obj.can_mail,
                portable: obj.can_tel_mob
              }
              localStorage.setItem('currentUser', JSON.stringify(user));
              this.loading = false;
              this.router.navigate(['profil']);
            }
            else {
              this.loading = false;
              this.errorLogin = true;
            }
          }
        },
        error => {
          console.error(error);
          this.loading = false;
          this.errorLogin = true;
        });
  }
}
